import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CssTransition from '../../components/Transition/CssTransition';
import { TransitionGroup } from 'react-transition-group';

import ToasterAlert from '../../components/Donation/ToasterAlert';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';

import DetailsForm from '../../components/Petition/DetailsForm';

import WidgetHeader from '../Widget/WidgetHeader';
import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../../containers/Widget/OverlayPartner';

import { onBackWithinCard, onGoToNextCard } from '../Widget/actions';
import { onPetitionComplete } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';
import { copyFor } from '../../copy/copy';

import { Container, Body, Content, ContentContainer } from '../DefaultStyles/Details';

const PetitionDetails = props => (
    <Container>
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <Body>
            <WidgetHeader />
            <Content>
                <ContentContainer>
                    <DetailsForm
                        onSubmit={values => {
                            props.cacheFormData(values);
                            if (props.skipEndCard) {
                                props.handleSkippingEndCard(
                                    props.nextAction,
                                    props.cards,
                                    props.onGoToNextCard
                                );
                            }
                            props.onPetitionComplete(
                                props.apiRequestData,
                                props.actionCompletedTime(),
                                values,
                                props.localRepData,
                                props.isMultiActionsCard,
                                props.actionIdentifier,
                                props.thankYouText,
                                props.thankYouTitle,
                                props.confirmationTitle,
                                props.useLocalRepresentative,
                                props.localRepresentativeState,
                                props.skipEndCard
                            );
                        }}
                        response={props.response}
                        onBackFromRepAction={() =>
                            props.onBackWithinCard(props.actionIdentifier, props.card)
                        }
                        isSubmitting={props.isSubmitting}
                    />
                </ContentContainer>
            </Content>
            <TransitionGroup>
                {props.petitionError && (
                    <CssTransition key="alert" in={props.petitionError}>
                        <ToasterAlert content={props.petitionError} />
                    </CssTransition>
                )}
            </TransitionGroup>
        </Body>
    </Container>
);

PetitionDetails.propTypes = {
    nextAction: PropTypes.object,
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    onPetitionComplete: PropTypes.func.isRequired,
    card: PropTypes.object.isRequired,
    cards: PropTypes.array.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    confirmationTitle: PropTypes.string,
    useLocalRepresentative: PropTypes.bool,
    response: PropTypes.string,
    localRepData: PropTypes.object,
    localRepresentativeState: PropTypes.number,
    petitionError: PropTypes.string,
    skipEndCard: PropTypes.bool,
    onGoToNextCard: PropTypes.func.isRequired,
    handleSkippingEndCard: PropTypes.func.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            nextAction,
            actionCompletedTime: getActionCompletedTime(state, 'petition'),
            actionIdentifier: state.widget.activeAction.identifier,
            apiRequestData: state.widget.apiRequestData,
            isSubmitting: state.petition.isSubmitting,
            localRepData: state.localRep.localRepData,
            response: state.widget.activeAction.text,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            cards: state.widget.cards,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            thankYouText: state.widget.activeAction.thankYouText || '',
            thankYouTitle: state.widget.activeAction.thankYouTitle,
            confirmationTitle:
                state.widget.activeAction.localRepresentativeState > 0
                    ? state.localRep.localRepData.length > 0
                        ? copyFor('feedback', 'sent', 'petition', undefined, {
                              recipientName:
                                  'Rep ' +
                                  state.localRep.localRepData.representative[0].fullName
                          })
                        : copyFor('feedback', 'signed', 'petition')
                    : copyFor('feedback', 'signed', 'petition'),
            useLocalRepresentative:
                state.widget.activeAction.localRepresentativeState > 0,
            localRepresentativeState: state.widget.activeAction.localRepresentativeState,
            petitionError: state.petition.petitionError,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction
        };
    },
    {
        onBackWithinCard,
        onPetitionComplete,
        onGoToNextCard,
        handleSkippingEndCard,
        cacheFormData
    }
)(PetitionDetails);



// WEBPACK FOOTER //
// ./src/containers/Petition/PetitionDetails.jsx